import {useMemo} from "react";

import type {FinancialApplicationSource} from "../../application/types/financial_application";
import {useGetConsentsQuery} from "../api/get_consents";
import type {IConsentTemplate} from "../types";

export const useConsentTemplates = (source: FinancialApplicationSource) => {
    const {data, isLoading, isError} = useGetConsentsQuery(source);

    return useMemo(() => {
        const templates = data?.results ?? [];

        return {
            defaultConsents: templates.filter((template): boolean => template.consent_mode === "default"),
            optionalConsents: templates.filter((template): boolean => template.consent_mode === "optional"),
            mandatoryConsents: templates.filter((template): boolean => template.consent_mode === "required"),
            isLoading,
            isError
        };
    }, [data, isLoading, isError]);
};

export type IConsentTemplatesGroups = Pick<ReturnType<typeof useConsentTemplates>, "defaultConsents" | "optionalConsents" | "mandatoryConsents">;

export type {IConsentTemplate};
import {useMemo} from "react";

import type {FinancialApplicationSource} from "../../application/types/financial_application";
import {useGetConsentsQuery} from "../api/get_consents";
import type {IConsentTemplate} from "../types";

export const useConsentTemplates = (source: FinancialApplicationSource) => {
    const {data, isLoading, isError} = useGetConsentsQuery(source);

    return useMemo(() => {
        const templates = data?.results ?? [];

        return {
            defaultConsents: templates.filter((template): boolean => template.consent_mode === "default"),
            optionalConsents: templates.filter((template): boolean => template.consent_mode === "optional"),
            mandatoryConsents: templates.filter((template): boolean => template.consent_mode === "required"),
            isLoading,
            isError
        };
    }, [data, isLoading, isError]);
};

export type IConsentTemplatesGroups = Pick<ReturnType<typeof useConsentTemplates>, "defaultConsents" | "optionalConsents" | "mandatoryConsents">;

export type {IConsentTemplate};
